var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "widget-card",
    class: {
      inactive: _vm.isInactive
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('edit', _vm.widget);
      }
    }
  }, [_c('div', {
    staticClass: "widget-attachment"
  }, [_vm.isInactive ? _c('div', {
    staticClass: "widget-attachment-overlay"
  }) : _vm._e(), _vm.imageLink ? _c('div', {
    staticClass: "widget-attachment-image",
    style: {
      backgroundImage: "url(".concat(_vm.imageLink, ")")
    }
  }) : _c('div', {
    staticClass: "widget-attachment-svg"
  }, [_c('svg', {
    attrs: {
      "width": "100%",
      "height": "60",
      "viewBox": "0 0 350 60"
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": "gradient",
      "y1": "0",
      "y2": "1"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "rgba(247, 158, 27, 0.7)",
      "offset": "0"
    }
  }), _c('stop', {
    attrs: {
      "stop-color": "rgba(235, 0, 27, 0.7)",
      "offset": "1"
    }
  })], 1)], 1), _c('g', {
    staticStyle: {
      "overflow": "hidden",
      "text-anchor": "middle",
      "font-weight": "700",
      "font-family": "Montserrat",
      "letter-spacing": "2px"
    },
    style: _vm.amountFoalFontSize
  }, [_c('text', {
    staticStyle: {
      "fill": "white",
      "stroke": "white",
      "stroke-width": "10",
      "white-space": "nowrap"
    },
    attrs: {
      "x": "175",
      "y": "50"
    }
  }, [_vm._v(" " + _vm._s(_vm.displayAmountGoal) + " ")]), _c('text', {
    staticStyle: {
      "fill": "url(#gradient)",
      "stroke": "none",
      "stroke-width": "0",
      "white-space": "nowrap"
    },
    attrs: {
      "x": "175",
      "y": "50"
    }
  }, [_vm._v(" " + _vm._s(_vm.displayAmountGoal) + " ")])])])])]), _c('div', {
    staticClass: "widget-content"
  }, [_c('div', {
    staticClass: "widget-title"
  }, [_vm._v(_vm._s(_vm.widget.description))]), _c('div', {
    staticClass: "widget-amount-bar"
  }, [_vm._v(_vm._s(_vm.displayAmountBar))]), _c('progress-loader', {
    attrs: {
      "percent": _vm.progressPercent,
      "inactive": _vm.isInactive
    }
  }), _vm.isShownCompletedIcon ? _c('div', {
    staticClass: "icon completed"
  }) : _vm._e()], 1), _c('div', {
    staticClass: "widget-actions",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.$emit('remove', _vm.widget);
      }
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "widget-action",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.$emit('edit', _vm.widget);
      }
    }
  }, [_c('span', {
    staticClass: "icon pencil"
  })]), _c('div', {
    staticClass: "widget-action",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.$emit('status', _vm.widget);
      }
    }
  }, [_c('span', {
    staticClass: "icon",
    class: {
      play: _vm.isInactive,
      stop: !_vm.isInactive
    }
  })])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "widget-action"
  }, [_c('span', {
    staticClass: "icon trash"
  })]);
}]

export { render, staticRenderFns }